import React, { useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Button } from 'primereact/button';
import { API_Root } from "../../../globalState";
import axios from 'axios'
import { Toast } from 'primereact/toast';

const fieldClass = "text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full";
const requiredEmptyClass = "border-red-400 text-base text-color surface-overlay p-2 border-1 border-solid border-round appearance-none outline-none w-full";

export function vehicleInfoIsComplete(v) {
    if (!v) {
        return false;
    }
    const vin = (v.vehicleVIN || '').trim();
    const make = (v.vehicleMake || '').trim();
    const model = (v.vehicleModel || '').trim();
    if (vin.length > 10) {
        return true;
    }
    return make.length > 0 && model.length > 0;
}

export const VehicleInfoLite = ({ onUpdate, value, showContact }) => {
    const [vin, setVin] = React.useState(value?.vehicleVIN ?? '');
    const [make, setMake] = React.useState(value?.vehicleMake ?? '');
    const [model, setModel] = React.useState(value?.vehicleModel ?? '');
    const [year, setYear] = React.useState(value?.vehicleYear ?? '');
    const [notes, setNotes] = React.useState(value?.vehicleNotes ?? '');
    const [stockNumber, setStockNumber] = React.useState(value?.stockNumber ?? '');
    const [contactName, setContactName] = React.useState(value?.contactName ?? '');
    const [contactNumber, setContactNumber] = React.useState(value?.contactNumber ?? '');

    const toast = useRef(null);

    useEffect(() => {
        if (value) {
            setVin(value.vehicleVIN ?? '');
            setMake(value.vehicleMake ?? '');
            setModel(value.vehicleModel ?? '');
            setYear(value.vehicleYear ?? '');
            setNotes(value.vehicleNotes ?? '');
            setStockNumber(value.stockNumber ?? '');
            setContactName(value.contactName ?? '');
            setContactNumber(value.contactNumber ?? '');
        }
    }, [value?.id]);

    useEffect(() => {
        let dto = {
            vehicleVIN: vin ?? '',
            vehicleMake: make ?? '',
            vehicleModel: model ?? '',
            vehicleYear: year ?? '',
            vehicleNotes: notes ?? '',
            stockNumber: stockNumber ?? '',
            tripVehicleId: value?.tripVehicleId ?? 1,
            contactName: contactName ?? '',
            contactNumber: contactNumber ?? ''
        }
        onUpdate(dto);
    }, [vin, make, model, year, notes, stockNumber, contactName, contactNumber]);

    const getVINInfo = () => {
        if (!vin || vin.trim().length < 8) {
            return;
        }
        var apiUrl = `${API_Root}api/trip/GetVehicleInfo?vin=${vin}`;
        axios.get(apiUrl).then((values) => {
            var vehicleInfo = values.data;
            setMake(vehicleInfo.make);
            setModel(vehicleInfo.model);
            setYear(vehicleInfo.year);
            setNotes(vehicleInfo.notes);
        });
    }

    const handleVINKeyDown = (event) => {
        if (event.key === 'Enter') {
            getVINInfo();
        }
    }

    const vinComplete = (vin || '').trim().length > 10;
    const getMakeClass = () => (vinComplete || (make && make.trim().length > 0)) ? fieldClass : requiredEmptyClass;
    const getModelClass = () => (vinComplete || (model && model.trim().length > 0)) ? fieldClass : requiredEmptyClass;

    return (
        <>
            <div className="p-2">
                <div className="field w-full md:w-24rem lg:w-30rem">
                    <div className="grid">
                        <div className="field col-9 md:col-8">
                            <InputText id="vin"
                                value={vin ?? ""}
                                onChange={(e) => setVin(e.target.value)}
                                onKeyDown={handleVINKeyDown}
                                className={fieldClass}
                                placeholder="VIN (optional)"
                            />
                            <small className="text-color-secondary text-sm block mt-1">Optional. Enter make and model if you do not have a VIN yet — Unknown or Loaner is fine.</small>
                        </div>
                        <div className="col-3 md:col-4">
                            <Button className="p-2" icon="pi pi-search" onClick={() => getVINInfo()} />
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-6 md:col-3">
                        <div className="field">
                            <input id="stockNumber"
                                value={stockNumber ?? ""}
                                onChange={(e) => setStockNumber(e.target.value)}
                                className={fieldClass}
                                placeholder="Stock #"
                            />
                        </div>
                    </div>
                    <div className="col-6 md:col-3">
                        <div className="field">
                            <input id="year"
                                value={year ?? ""}
                                onChange={(e) => setYear(e.target.value)}
                                className="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                                placeholder="Year"
                            />
                        </div>
                    </div>
                    <div className="col-6 md:col-3">
                        <div className="field">
                            <input id="make"
                                value={make ?? ""}
                                onChange={(e) => setMake(e.target.value)}
                                className={getMakeClass()}
                                placeholder="Make or Unknown"
                            />
                        </div>
                    </div>
                    <div className="col-6 md:col-3">
                        <div className="field">
                            <input id="model"
                                value={model ?? ""}
                                onChange={(e) => setModel(e.target.value)}
                                className={getModelClass()}
                                placeholder="Model or Loaner"
                            />
                        </div>
                    </div>
                </div>
                {showContact && (
                    <div className="grid mt-2">
                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="contactName" className="text-sm">Contact name</label>
                                <input id="contactName"
                                    value={contactName ?? ""}
                                    onChange={(e) => setContactName(e.target.value)}
                                    className="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                                    placeholder="Contact name"
                                />
                            </div>
                        </div>
                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="contactNumber" className="text-sm">Contact phone</label>
                                <InputMask id="contactNumber"
                                    mask="(999) 999-9999"
                                    value={contactNumber ?? ""}
                                    onChange={(e) => setContactNumber(e.target.value)}
                                    className="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                                    placeholder="Contact phone"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Toast ref={toast} />
        </>);

};
